import { UnityData, HeaderContent } from "../../../LinkDataInterface";
import {
  mail,
  cartographe,
  github,
  wiki,
  accreds,
  boutique,
  espaceStaff,
  vault,
} from "../permanant";
import bg from "./JI-2026.png";
import bgPortrait from "./JI-2026-Portrait.png";

const header: HeaderContent = {
  driveSearch: {
    url: "https://drive.google.com/drive/search?q=",
    color: "rgba(78, 52, 112, 0.47)",
    text: "rgb(255, 246, 240)",
  },
  logo: "https://2023.japan-impact.ch/img/logo.png",

  quickLinks: [
    mail,
    vault,
    cartographe,
    accreds,
    boutique,
    espaceStaff,
    github,
    wiki,
  ],
};

export const defaultJiData: UnityData = {
  name: "Japan Impact",
  style: {
    button: {
      color: "rgba(255, 246, 240, 0.9)",
      text: "#000000",
      hover: "rgba(78, 52, 112, 0.8)",
      textHover: "rgb(255, 246, 240)",
    },
    background: {
      imgLandscape: bg,
      imgPortrait: bgPortrait,
      color: "#b2bcda",
    },
  },
  groups: [],
  header: header,
};
